import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs';
import { LoadingSpinner } from '../../components/loading-spinner/loading-spinner';
import { Auth } from '../../services/auth';

@Component({
  selector: 'app-token',
  imports: [LoadingSpinner],
  templateUrl: './token.html',
  styleUrl: './token.css',
})
export class TokenComponent {
  protected readonly router = inject(Router);
  protected readonly route = inject(ActivatedRoute);
  protected readonly authService = inject(Auth);

  missingToken = signal<boolean>(false);
  invalidToken = signal<boolean>(false);

  constructor() {
    this.route.queryParams.pipe(take(1)).subscribe((params) => {
      const accessToken = params['accessToken'];
      const refreshToken = params['refreshToken'];
      if (!accessToken && !refreshToken) {
        this.missingToken.set(true)
        return;
      }
      if (accessToken) {
        localStorage.setItem('accessToken', accessToken);
      }
      if (refreshToken) {
        localStorage.setItem('refreshToken', refreshToken);
      }
      this.authService.verifyToken(accessToken).pipe(take(1)).subscribe({
        next: (response) => {
          console.log(response);
          if (response) {
            this.router.navigate(['/app']);
          } else {
            this.invalidToken.set(true);
          }
        }, error: (error) => {
          console.error(error);
          this.invalidToken.set(true);
        }
      });
    });
  }
}
